import { getMinStaySettings, saveMinStaySettings } from '@common/api/minstay';
import { MinStayQueryKeys } from '@common/types/query-keys';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useMemo } from 'react';

export const useMinStaySettings = () => {
  const minStaySettingsQuery = useQuery({
    queryKey: [MinStayQueryKeys.GET_MIN_STAY_SETTINGS],
    queryFn: getMinStaySettings
  });

  const minStaySettings = useMemo(() => {
    return minStaySettingsQuery.data;
  }, [minStaySettingsQuery.data]);

  return {
    minStaySettingsQuery,
    minStaySettings
  };
};

export const useSaveMinStaySettings = () => {
  const queryClient = useQueryClient();

  const {
    mutate,
    isPending: isLoading,
    isSuccess
  } = useMutation({
    mutationKey: [MinStayQueryKeys.SAVE_MIN_STAY_SETTINGS],
    mutationFn: (settings: string) => {
      return saveMinStaySettings(settings);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [MinStayQueryKeys.GET_MIN_STAY_SETTINGS] });
    }
  });

  return {
    saveMinStaySettings: mutate,
    isLoading,
    isSuccess
  };
};
